<template>
    <div style="text-align: center; margin: 12px">
        
        <img src="../assets/SSL-opti.png">
        
<!--        &lt;!&ndash;- Secure Site Seal - DO NOT EDIT -&ndash;&gt;-->
<!--        <span id="ss_img_wrapper_115-55_image_en"><a href="http://www.alphassl.com/ssl-certificates/wildcard-ssl.html"-->
<!--                                                     target="_blank" title="SSL Certificates"><img-->
<!--                alt="Wildcard SSL Certificates" border=0 id="ss_img"-->
<!--                src="//seal.alphassl.com/SiteSeal/images/alpha_noscript_115-55_en.gif"-->
<!--                title="SSL Certificate"></a></span>-->

<!--&lt;!&ndash;        <script type="text/javascript" src="//seal.alphassl.com/SiteSeal/alpha_image_115-55_en.js"></script>&ndash;&gt;-->
<!--        &lt;!&ndash;- Secure Site Seal - DO NOT EDIT -&ndash;&gt;-->

<!--        <div ref="scriptWrapper"></div>-->
    </div>
</template>

<script>
    export default {
        name: "sslSeal",

        // mounted() {
        //     let scriptEl = document.createElement('script');
        //     scriptEl.setAttribute('src', 'https://seal.alphassl.com/SiteSeal/alpha_image_115-55_en.js');
        //     // scriptEl.setAttribute('data-some-param', 'paramvalue');
        //     this.$refs.scriptWrapper.appendChild(scriptEl);
        // },
    }
</script>

<style lang="scss" scoped>

    img{
        width: 130px;
        height: auto;
    }

</style>